import React from "react";
import {
  Tooltip,
  Position,
  NonIdealState,
  Intent,
  Button,
} from "@blueprintjs/core";
import FadeIn from "react-fade-in";

import "../../../assets/components/TableFeebacksTable.css";

class CreatePanelFeedbacksTable extends React.Component {
  handleDeleteFeedback = (id) => {
    const { onDeleteFeedback } = this.props;

    onDeleteFeedback(id);
  };

  render() {
    const { feedbacks, onOpenDialog, hasBeenPlayed } = this.props;

    if (feedbacks.length <= 0)
      return (
        <FadeIn>
          <div>
            <NonIdealState
              icon="help"
              title="No Feedback Question Yet"
              description={
                hasBeenPlayed
                  ? "You can't add feedback questions as the session has already been played"
                  : "You did not create feedback questions yet"
              }
              action={
                <Button
                  intent={Intent.PRIMARY}
                  disabled={feedbacks.length >= 20 || hasBeenPlayed}
                  rightIcon="add"
                  text="Add Feedback Question"
                  onClick={onOpenDialog}
                />
              }
            />
          </div>
        </FadeIn>
      );
    return (
      <FadeIn>
        <div>
          <div className="text-right">
            <Tooltip
              disabled={feedbacks.length < 5 || hasBeenPlayed}
              content="You have reached the maximum amount of feedbacks"
              position={Position.TOP_LEFT}
            >
              <Button
                intent={Intent.PRIMARY}
                disabled={feedbacks.length >= 20 || hasBeenPlayed}
                rightIcon="add"
                text="Add Feedback Question"
                style={{ marginBottom: "20px" }}
                onClick={onOpenDialog}
              />
            </Tooltip>
          </div>
          <div>
            <table className="bp3-html-table full-width">
              <theadc className="hidden-xs hidden-sm">
                <tr>
                  <th>Type</th>
                  <th>Question</th>
                  <th>Left legend</th>
                  <th>Right legend</th>
                  <th />
                </tr>
              </theadc>
              <tbody className="feedz">
                {feedbacks.map((f, index) => (
                  <tr key={index}>
                    <td>{f.type === "OPEN" ? "Open" : "Closed"}</td>
                    <td>{f.question}</td>
                    <td>{f.leftLegend}</td>
                    <td>{f.rightLegend}</td>
                    <td style={{ textAlign: "right" }}>
                      <Button
                        icon="trash"
                        minimal={true}
                        onClick={() => this.handleDeleteFeedback(f.id)}
                        disabled={hasBeenPlayed}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </FadeIn>
    );
  }
}

export default CreatePanelFeedbacksTable;
